export const SELECT_UNASSIGNED = '__unassigned__'
export const SELECT_CLEAR = '__clear__'
export const SELECT_NONE = '__none__'
